import React from 'react'
import { Switch } from '@mui/material'
import { Column, ColumnAction } from '@/components/Table'
import Button from '@/components/Button'
import { Row } from './components'
import { Delete, ImageIcon } from '@/icon'
import edit_icon from '@/asset/img/edit_icon.webp'
import { ForwardingConfigDetails } from '@/types'

// const CheckboxIcon = styled("div")(() => ({
//   width: "16px",
//   height: "16px",
//   border: "1px solid #D9D9D9",
//   borderRadius: "4px",
//   backgroundColor: "#F7F7F7",
// }));

// const TableCheckBox = ({ checked }: { checked: boolean }) => {
//   return (
//     <Checkbox
//       icon={<CheckboxIcon />}
//       size="small"
//       checked={checked}
//       disabled={!checked}
//       onChange={null}
//       disableRipple={true}
//       sx={{ cursor: "default", padding: "0px" }}
//     />
//   );
// };

export const Columns: (
  callback: (action: ColumnAction, data: ForwardingConfigDetails) => () => void
) => Column<ForwardingConfigDetails & { action?: unknown }>[] = (callback) => [
  {
    id: 'desc',
    label: '通知策略',
    ellipsis: true,
  },
  {
    id: 'orgs',
    label: '通知条件',
    ellipsis: true,
    format: ({ row }) => {
      const orgs = (row?.orgs?.map((org) => org?.name) ?? []).join(',')
      const apps = (row?.apps?.map((app) => app?.name) ?? []).join(',')
      const names =
        orgs?.length > 0 && apps?.length > 0
          ? [orgs, '/', apps].join(' ')
          : apps + orgs
      return names
    },
  },
  {
    id: 'enabled',
    label: '状态',
    width: 80,
    format: ({ row }) => (
      <Switch
        size="small"
        checked={row?.enabled === 1}
        onClick={callback('status', row)}
      />
    ),
  },
  {
    id: 'action',
    label: '操作',
    width: 240,
    format: ({ row }) => {
      return (
        <Row sx={{ gap: '8px' }}>
          <Button
            type="text"
            sx={{
              minWidth: 'auto',
              padding: '0',
              backgroundColor: 'transparent',
              fontSize: '14px',
            }}
            onClick={callback('test', row)}
            disabled={row?.enabled === 0}
          >
            发信测试
          </Button>

          <Button
            type="text"
            sx={{
              minWidth: 'auto',
              padding: '0 8px',
              backgroundColor: 'transparent',
              fontSize: '14px',
            }}
            onClick={callback('edit', row)}
            startIcon={<ImageIcon src={edit_icon} sx={{ width: 12 }} />}
          >
            设置
          </Button>

          {row?.type === 'normal' && (
            <Button
              type="danger"
              sx={{
                minWidth: 'auto',
                padding: '0 8px',
                backgroundColor: 'transparent',
                fontSize: '14px',
              }}
              onClick={callback('delete', row)}
              startIcon={<Delete sx={{ fontSize: '20px' }} />}
            >
              删除
            </Button>
          )}
        </Row>
      )
    },
  },
]
